import { Tag, Typography } from 'antd';

const { Text } = Typography;

export const LocationTag = ({
  location,
  onClick,
  copybale = false,
}: {
  location?: { lat?: number; lng?: number };
  onClick?: () => void;
  copybale?: boolean;
}) => (
  <Tag onClick={onClick} style={{ cursor: onClick ? 'pointer' : undefined }}>
    {location && (location.lat != null || location.lng != null) ? (
      <Text
        copyable={
          copybale
            ? {
                text: `${location.lat?.toFixed(5) ?? ''}, ${location.lng?.toFixed(5) ?? ''}`,
              }
            : false
        }
      >
        {location.lat != null && `Lat: ${location.lat.toFixed(5)}`}
        {location.lat != null && location.lng != null && ', '}
        {location.lng != null && `Lng: ${location.lng.toFixed(5)}`}
      </Text>
    ) : (
      'Location not available'
    )}
  </Tag>
);
